//
//
//
//
//


import TableIndex from "@/0/components/comForm/comFormIndex/comTableIndex/comTableIndex1";
export default {
  
  props: ["dataConfig","parentObj","tabPage"],
  components: {
    "table-index": TableIndex,
  },
  data() {
    return {
    };
  },

  created(){
    console.log(this.dataConfig,'dataConfig')
  },

  mounted() {


  },
  methods: {

    $getSubmitData(){

      console.log("this.parentObj=====",this.parentObj);
      var formData = null;
      
      if(this.parentObj){
        formData = this.parentObj.$getSubmitData();
      }else{
        formData = this.$parent.$getSubmitData();
      }
      return formData;
    },

    $getActionObj(){
      var actionObj = this.$parent.$getActionObj();
      return actionObj;
    },
    
  }
};
